import { Component, HostBinding, Output, EventEmitter } from '@angular/core';
import { Response } from '@angular/http';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { SessionService } from '../../shared/services/session/session.service';
import { LoginService } from '../../shared/services/login/login.service';
import { SettingsService } from '../../shared/services/settings/settings.service';
import { BalanceService } from '../../shared/balance/balance.service';
import { LoginRequest } from '../../shared/domain/login-request';
import { User } from '../../shared/domain/user';

@Component({
  moduleId: module.id,
  selector: 'vit-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('void', style({
        'opacity': '0'
      })),
      transition('void => *', animate('200ms linear')),
      transition('* => void', animate('200ms linear'))
    ])
  ]
})
export class LoginComponent {
  @HostBinding('@fadeIn') fadeIn = '';

  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  username: string;
  password: string;
  rememberMe: boolean;
  loading: boolean;
  error: boolean;

  constructor(public sessionService: SessionService,
              public loginService: LoginService,
              public balanceService: BalanceService,
              public settingsService: SettingsService) {
    this.error = false;
    this.loading = false;
  }

  login() {

    this.error = false;
    this.loading = true;

    let login = new LoginRequest();

    login.Password = this.password;
    login.AccountNr = this.username;
    login.RememberMe = this.rememberMe;

    this.loginService.validateLogin(login).subscribe(
        (response: any) => this.handleLoginResponse(response),
        (error: any) => this.handleLoginError(error));
  }


  handleLoginError(error: Error) {
    this.sessionService.punter = null;
    this.error = true;
    this.loading = false;
  }

  handleLoginResponse(response: Response) {
    this.settingsService.handleSettingsResponse(response.json());
    this.sessionService.punter = new User(this.username, null);
    this.balanceService.updateBalance();
    this.loading = false;
    this.close.emit();
  }
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/game-view/login/login.component.ts